import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Mirador } from 'src/app/models/mirador';
import { MiradorCustomList } from 'src/app/models/mirador-custom-list';
import { MiradorList } from 'src/app/models/mirador-list';
import { ListManagerService } from 'src/app/services/list-manager.service';
import { MiradoresService } from 'src/app/services/miradores.service';
import { LinkManagerService } from 'src/app/services/link-manager.service';
import { OrganizerService } from 'src/app/services/organizer.service';
import { ListAlbumDetailService } from 'src/app/services/list-album-detail.service';
import { UtilService } from 'src/app/services/util.service';
import { ExperienceService } from 'src/app/services/experience.service';
import { ListExperiencesService } from 'src/app/services/list-experiences.service';
import { Experience } from 'src/app/models/ToursModels';

@Component({
  selector: 'app-horizontal-list-experiences',
  templateUrl: './horizontal-list-experiences.component.html',
  styleUrls: [
    './styles/user-profile.page.scss',
    './styles/user-profile.shell.scss',
    './styles/user-profile.ios.scss',
    './styles/user-profile.md.scss',
  ],
})
export class HorizontalListExperiencesComponent implements OnInit {

  @Input() listId: string;
  @Input() customTitle?: string;

  list: MiradorList | MiradorCustomList;
  constructor(private utilService: UtilService,
    private listService: ListExperiencesService,
    private router: Router,
    private ORGService: OrganizerService,
    private linkManager: LinkManagerService,
    public experienceService: ExperienceService,) { }

  ngOnInit() {
    this.listService.getListById(this.listId).then((res) => {
      if (res) {
        this.list = res;
      }

    });
  }

  generateAndOpenDinamikLink(path) {
    const dinamikLink = this.linkManager.generateDinamicLink(path);
    window.open(dinamikLink, '_self')
  }

  seeDetail(experience: Experience) {
    this.router.navigate([`/experience/${experience._id}`]);
  }


}
